import script from "./AuditorList.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditorList.vue?vue&type=script&setup=true&lang=js"

import "./AuditorList.vue?vue&type=style&index=0&id=08ae5bdf&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ae5bdf"]])

export default __exports__